import { render, staticRenderFns } from "./PluginDetail.vue?vue&type=template&id=049f5ab9&scoped=true&"
import script from "./PluginDetail.vue?vue&type=script&lang=js&"
export * from "./PluginDetail.vue?vue&type=script&lang=js&"
import style0 from "./PluginDetail.vue?vue&type=style&index=0&id=049f5ab9&prod&lang=css&"
import style1 from "./PluginDetail.vue?vue&type=style&index=1&id=049f5ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f5ab9",
  null
  
)

export default component.exports